import {
    clearFollow,
    clearFollowItems,
    clearUserAction,
    commonCityAction,
    commonStateAction,
    receiveNewData,
    receiveShops,
    receiveSpecials,
    receiveStyles,
    receiveUser,
    receiveUserError,
    receiveUsers,
    receiveUserSave,
    requestDifferentItems,
    requestNewData,
    requestShops,
    requestSpecials,
    requestStyles,
    requestUser,
    requestUsers,
    requestUserSave
} from "./actions";
import User from "../_data/models/User";
import {plainToClass} from "class-transformer";
import UsersRepository from "../_repositories/userRepository";
import CommonRepository from "../_repositories/commonRepository";
import {getCurrentUser, toastSuccess} from "../_helpers/utils";
import Meta from "../_data/models/Meta";
import {addDataAction, updateDataAction} from "../_data/actions";
import {ResourceType} from "../_helpers/data";
import {userByIdSelector} from "../_data/selectors";

const loggedUser = getCurrentUser();

export function fetchUser(id: number | string) {
    return (dispatch, getState) => {
        dispatch(requestUser());

        const users = getState().data.users;
        //get user from state nase on id
        let user = users.find((user) => user.name == id as string);
        if (!user)
            user = users.find((user) => user.id == id as number);

        //if still null get from api
        if (!user) {
            dispatch(requestNewData());
            dispatch(clearUserAction());
            UsersRepository.get(id).then(data => {
                const {error, user} = data;
                if (!error) {
                    dispatch(addDataAction({
                        resource: ResourceType.user,
                        data: user
                    }));
                    dispatch(receiveUser({
                        userID: user.id
                    }));
                    dispatch(fetchUserStyles(user.id));
                    dispatch(receiveNewData());
                } else {
                    dispatch(receiveUserError());
                }
            });
        } else {
            //check if user is already loaded on page (following and follower redirect; back button)
            const active_user = getState().user.userID && getState().user.userID == user.id;
            if (!active_user) {
                dispatch(clearUserAction());
                dispatch(receiveUser({
                    userID: user.id
                }));

                dispatch(fetchUserStyles(user.id));
            }

            //update user data in background
            UsersRepository.get(id).then(data => {
                const {error, user} = data;
                if (!error) {
                    dispatch(updateDataAction({
                        resource: ResourceType.user,
                        data: user
                    }));
                }
            });
        }
    }
}

export function fetchUserStyles(id: number, page: number = null, perPage: number = 10) {
    return (dispatch, getState) => {
        dispatch(requestStyles({
            tab: "style",
        }));
        UsersRepository.getStylesById(id, page, perPage).then(data => {
            const {styles, meta} = data;
            returnDispatch(dispatch, getState(), styles, meta, ResourceType.style);
        });
    }
}

export function fetchUserLikedStyles(id: number, page: number = null, perPage: number = 10) {
    return (dispatch, getState) => {
        dispatch(requestStyles({
            tab: "likedStyle"
        }));
        UsersRepository.getLikedStylesById(id, page, perPage).then(data => {
            const {liked_styles, meta} = data;
            returnDispatch(dispatch, getState(), liked_styles, meta, ResourceType.style);
        });
    }
}

export function fetchUserSpecials(id: number, page: number = null, perPage: number = 10) {
    return (dispatch, getState) => {
        dispatch(requestSpecials({
            tab: "special"
        }));
        UsersRepository.getSpecialsById(id, page, perPage).then(data => {
            const {specials, meta} = data;
            returnDispatch(dispatch, getState(), specials, meta, ResourceType.special);
        });
    }
}

export function fetchUserFollowing(id: number, page: number = null, perPage: number = 10) {
    return (dispatch, getState) => {
        dispatch(requestUsers());
        UsersRepository.getFollowingUsersById(id, page, perPage).then(data => {
            const {users_followed, meta} = data;
            returnDispatch(dispatch, getState(), users_followed, meta, ResourceType.user);
        });
    }
}

export function fetchShopFollowing(id: number, page: number = null, perPage: number = 10) {
    return (dispatch, getState) => {
        dispatch(requestShops());
        UsersRepository.getFollowingShopsById(id, page, perPage).then(data => {
            const {liked_salons, meta} = data;
            returnDispatch(dispatch, getState(), liked_salons, meta, ResourceType.shop);
        });
    }
}

export function fetchUserFollowers(id: number, page: number = null, perPage: number = 10) {
    return (dispatch, getState) => {
        dispatch(requestUsers());
        UsersRepository.getFollowersById(id, page, perPage).then(data => {
            const {followers, meta} = data;
            returnDispatch(dispatch, getState(), followers, meta, ResourceType.user);
        });
    }
}

interface Result {
    id: number;
}

function returnDispatch(dispatch: any, state: any, data: {}[], meta: Meta, resource: string) {
    const ids: number[] = data.map((x: Result) => x.id);

    dispatch(addDataAction({
        resource: resource,
        data: data
    }));

    if (resource == ResourceType.user) {
        return dispatch(receiveUsers({
            userIDs: ids,
            meta: plainToClass(Meta, meta),
        }));
    }
    else if (resource == ResourceType.shop) {
        return dispatch(receiveShops({
            shopIDs: ids,
            meta: plainToClass(Meta, meta),
        }));
    }
    else if (resource == ResourceType.special) {
        return dispatch(receiveSpecials({
            specialIDs: ids,
            meta: plainToClass(Meta, meta),
        }));
    }
    else if (resource == ResourceType.style) {
        return dispatch(receiveStyles({
            styleIDs: ids,
            meta: plainToClass(Meta, meta),
        }));
    }
}

export function fetchStateList() {
    return (dispatch) => {
        CommonRepository.getStates().then(data => {
            const {states} = data;
            return dispatch(commonStateAction({...data, stateList: states}));
        })
    }
}

export function fetchCityList(state: string) {
    return (dispatch) => {
        CommonRepository.getCities(state).then(data => {
            const {cities} = data;
            return dispatch(commonCityAction({...data, cityList: cities}));
        })
    }
}

export function saveProfile(formData: User) {
    return (dispatch) => {
        dispatch(requestUserSave());
        UsersRepository.saveProfile(formData).then(data => {
            toastSuccess(`Successfully saved Profile.`);
            return dispatch(receiveUserSave());
        })
    }
}

export function initFollow() {
    return (dispatch) => {
        dispatch(clearFollow());
    }
}

export function changeFollow() {
    return (dispatch) => {
        dispatch(clearFollowItems());
    }
}

export function clearItems() {
    return (dispatch) => {
        dispatch(requestDifferentItems());
    }
}

export function initializeUserEdit() {
    return (dispatch, getState) => {
        dispatch(fetchUser(loggedUser.id));

        const currentUser = userByIdSelector(getState(), loggedUser.id);

        dispatch(fetchStateList());
        dispatch(fetchCityList(currentUser.state));
    }
}


// WEBPACK FOOTER //
// ./app/client/user/middlewares.ts